import { useEffect as a } from "react";
import { isSafari as d } from "./detect-browser.js";
const v = (u, o, e, c) => {
  a(() => {
    if (!o) return;
    const m = (s) => {
      if (!o) return;
      const r = s.target, t = u.current, n = c.current;
      t != null && t.contains(r) || n != null && n.contains(r) || e();
    }, i = (s) => {
      const r = s.target, t = u.current, n = c.current;
      t != null && t.contains(r) || n != null && n.contains(r) || d() || e();
    };
    return document.addEventListener("mousedown", m), document.addEventListener("focusin", i), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("focusin", i);
    };
  }, [o, e]);
};
export {
  v as useFocusOutside
};
